import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import IntrusionVolume from '../IntrusionVolume/IntrusionVolume.js';

var IntrusionVolumeComponent = function IntrusionVolumeComponent(_ref) {
  var onIntrusionVolumeUpdated = _ref.onIntrusionVolumeUpdated,
    toggled = _ref.toggled,
    originalIntrusionVolume = _ref.originalIntrusionVolume;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    intrusionVolume = _useState2[0],
    setIntrusionVolume = _useState2[1];
  useEffect(function () {
    if (originalIntrusionVolume !== undefined) {
      setIntrusionVolume(originalIntrusionVolume);
      onIntrusionVolumeUpdated(originalIntrusionVolume);
    }
  }, [originalIntrusionVolume]);
  var setNewIntrusionVolume = function setNewIntrusionVolume(value) {
    onIntrusionVolumeUpdated(value);
  };
  return /*#__PURE__*/React.createElement(IntrusionVolume, {
    isToggled: toggled || intrusionVolume,
    onChange: setNewIntrusionVolume
  });
};
IntrusionVolumeComponent.propTypes = {
  onIntrusionVolumeUpdated: PropTypes.func.isRequired,
  toggled: PropTypes.bool,
  originalIntrusionVolume: PropTypes.bool.isRequired
};
IntrusionVolumeComponent.defaultProps = {
  toggled: false
};

export { IntrusionVolumeComponent as default };
